<template>
    <section>
        <div class="page-wrap">
            <div class="container">
                <div class="box-content text-center">
                    <h2>TITAN PROMENADE TRIBUTE PROGRAM</h2>
                    <div class="font-lg">
						<p>Make your mark at CSUF by April 30, 2022!</p>
                        <p>
                            Cal State Fullerton proudly invites you to etch your name in Titan history by securing a personalized paver, tree dedication or study nook naming on the new Titan Promenade. This iconic gateway leads from the south entrance of campus to the Pollak Library at heart of university with Titan pride of full display. The promenade includes incredible outdoor learning spaces with new furniture, beautiful landscaping, Wi-Fi towers and so much more. 
                        </p>
						<p>
							Each paver or plaque can be inscribed with your personal message and will be installed along the Titan Promenade, paving the way for future students and visitors to campus. To be a part of history, place your order today! Honor a classmate, CSUF graduate, Titan sports fan, faculty or staff member. 
						</p>
						<p>
							Make your mark and support Cal State Fullerton!
						</p>
                        <p class="red"><!--
                            Important information: Orders placed by Nov. 24, 2021 will be included in the Phase II installation scheduled for Mar. 2022 and will receive a keepsake certificate by Dec. 24, 2021. Donations made in December will be processed by Cal State Fullerton in January. Due to processing requirements, you will be sent a tax receipt reflecting a donation made in 2022. Orders placed Nov. 25, 2021 – Apr. 30, 2022 will be installed in Sept. 2022.-->
                        </p>
                        <router-link to="/shop" class="btn">ORDER NOW!</router-link>
						<p><br />
							<i>
								All gifts support the It Takes a Titan campaign for Cal State Fullerton.
							</i>
						</p>
						<!--<div class="img-wrap">-->
							<img src="images/aboutlogo.png" alt="IT TAKES A TITAN" class="about-img" />
						<!--</div>-->
                    </div>
                </div><!--
                <div class="box-content about">
                    <div class="row">
                        <div class="col-sm-12">
                            <span class="dotted-line"></span> 
                        </div>
                    </div> 
                    <h2 class="text-center">PRODUCT SELECTIONS</h2>
                    <div class="row brick-options">
                        <div class="col-sm-4">
                            <div class="img-wrap">
                                <img class="img-responsive" src="images/about12x12.png" alt="">
								<div>&nbsp;</div>
                            </div>
                        </div>
                        <div class="xs-only-spacer visible-xs"></div>
                        <div class="col-sm-4">
                            <div class="img-wrap">
                                <img class="img-responsive" src="images/aboutpalm.png" alt="">
								<div>&nbsp;</div>
                            </div>
                        </div>
						<div class="xs-only-spacer visible-xs"></div>
                        <div class="col-sm-4">
                            <div class="img-wrap">
                                <img class="img-responsive" src="images/aboutcrepemyrtle.png" alt="">
								<div>&nbsp;</div>
                            </div>
                        </div>
                    </div>
					<div class="row brick-options">
                        <div class="col-sm-4">
                            <div class="img-wrap">
                                <img class="img-responsive" src="images/aboutstudynook.png" alt="">
								<div>&nbsp;</div>
                            </div>
                        </div>
                        <div class="xs-only-spacer visible-xs"></div>
                        <div class="col-sm-4">
                            <div class="img-wrap">
                                &nbsp;
                            </div>
                        </div>
						<div class="xs-only-spacer visible-xs"></div>
                        <div class="col-sm-4">
                            <div class="img-wrap">
                                &nbsp;
                            </div>
                        </div>
                    </div>
				</div>
                <div class="box-content text-center">
                    <div class="font-lg">
                        <router-link to="/shop" class="btn btn-multiline-text">
                            CLICK HERE TO CREATE YOUR PERSONALIZED PRODUCT!
                        </router-link>
                    </div>
                </div>-->
            </div>
        </div>
    </section>
</template>

<script type="text/jsx">
    export default {
        name: 'about'
    }
</script>

<style lang="scss" scoped>
    a.btn {
        color: #fff;
        background-color: #005596; // $wfbp-blue
        &:hover,
        &:focus {
            background-color: #003762; // $wfbp-midblue
        }
    }
    a:hover, a:visited, a:link, a:active {
        text-decoration: none;
    }
    p.red {
        color: red;
    }
</style>



// WEBPACK FOOTER //
// About.vue?a3a67d2a